import React from 'react';
import { useMediaQuery } from 'react-responsive';
import DomainRegistrationContent from './DomainRegistrationContent';

const Mobile = ({ children }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  return isMobile ? children : null;
};

const MobileResponsive = ({
  open,
  domainName,
  handleKeyDown,
  handleDomainOpen,
  handleOnChange,
}) => (
  <Mobile>
    <DomainRegistrationContent
      open={open}
      domainName={domainName}
      handleKeyDown={handleKeyDown}
      handleDomainOpen={handleDomainOpen}
      handleOnChange={handleOnChange}
    />
  </Mobile>
);

export default MobileResponsive;
